import type { FC } from 'react';
import { memo, useMemo } from 'react';
import type { Route } from '../../bootstrap/router/hooks';
import { Text, Title } from '../../bootstrap/typography';
import s from './index.module.scss';

export const HighlightsPage: FC = memo(() => {
  const formatDate = (isoDate: string) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className={s.page}>
      <Title size={1} color={1} className={s.title}>
        Highlights
      </Title>
      <Text size="1" color="3" className={s.proudOf}>
        A collection of my articles, talks, interviews, achievements
      </Text>
      <div className={s.hlWrapper}>
        <p className={s.hlTitle}>{`${formatDate('2025-03-23')}`} | Got some cool merch :)</p>
        <p className={s.hlDescription}>
          It was an amazing event — great atmosphere, interesting challenges, and a lot of strong
          people around. Really enjoyed it and even got some awesome merch.
        </p>
        <div className={s.hlImages}>
          <img
            src="static/images/2359.jpg"
            alt=""
            className={s.hlImage}
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>

      <div className={s.hlWrapper}>
        <p className={s.hlTitle}>{`${formatDate('2025-03-19')}`} | Solveva Fest 2025 Hackathon</p>
        <p className={s.hlDescription}>
          In a short timeframe, I led a team to build a solution that significantly improved
          internal processes and saved valuable time. Competing against mostly senior-level
          developers, we placed 4th out of 12 teams at Solveva Fest Hackathon.
        </p>
        <div className={s.hlImages}>
          <img
            src="static/images/3006.jpg"
            alt=""
            className={s.hlImage}
            style={{ maxWidth: '50%' }}
          />
          <img
            src="static/images/8388.jpg"
            alt=""
            className={s.hlImage}
            style={{ maxWidth: '50%' }}
          />
        </div>
      </div>

      <div className={s.hlWrapper}>
        <p className={s.hlTitle}>
          {`${formatDate('2023-06-05')}`} | Earned MongoDB SI Associate Certification
        </p>
        <p className={s.hlDescription}>
          Solid fundamentals in data modeling, aggregation, and performance. Another step forward.{' '}
          <a href="https://learn.mongodb.com/c/MYKh83BVQ3et3nY8EsWvxg" className={s.hlLink}>
            Link
          </a>{' '}
          :)
        </p>
        <div className={s.hlImages}>
          <img
            src="static/images/7055.jpg"
            alt=""
            className={s.hlImage}
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>

      <div className={s.hlWrapper}>
        <p className={s.hlTitle}>{`${formatDate('2022-06-11')}`} | New merch from TM2</p>
        <p className={s.hlDescription}>
          Got a nice mug from Technology Metals Market — appreciated.
        </p>
        <div className={s.hlImages}>
          <img
            src="static/images/2357.jpg"
            alt=""
            className={s.hlImage}
            style={{ maxWidth: '100%' }}
          />
        </div>
      </div>
    </div>
  );
});

export const useHighlightsRoute = () => {
  const route = useMemo<Route>(
    () => ({
      path: '/highlights',
      element: HighlightsPage
    }),
    []
  );

  return { route };
};
